import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { AppraisalCommunicationStore } from '../stores';

export const useAppraisalCommunicationStore = () => useContext<{
  appraisalCommunicationStore: AppraisalCommunicationStore
}>(StoreContext);
